export { BioEntitiesResultsList } from './BioEntitiesResultsList.component';
